import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { ReactComponent as CalendarIcon } from "../../../Assets/svg/calendar.svg";
import { Container, Row, Col } from "react-bootstrap";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import greyIcon from "../../../Assets/svg/grey.svg";
import yellowIcon from "../../../Assets/svg/yellow.svg";
import SearchWithAPI from "../../common/searchbox/searchbox.js";
import ModalCloseIcon from "../../../Assets/svg/close-modal.svg";
import { apiCall } from "../../../services/api-service.js";

const BulkAssignUpdateModal = ({ ticketList, onHide, success }) => {
 const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "520px",
      height: "460px",
      /* textAlign: "center", */
      overflowY: "auto",
    },
  };

  function modalTitle(updateStatus) {
    if (updateStatus === "Hold") {
      return "Holding remarks";
    } else if (updateStatus === "Closed") {
      return "Closing remarks";
    } else if (updateStatus === "Completed") {
      return "Completing remarks";
    } else {
      return "";
    }
  }
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [selectedEmailOption, setEmailOption] = useState(null);
  const [selectedTeamOption, setTeamOption] = useState(null);
  const [remarkType, setRemarksType] = useState("single");

  const [selectedTicketList, setSelectedTicketList] = useState([]);
  const [groupedError, setGroupedError] = useState({});

  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDatePicker);
    };
  }, []);
  const alertDatePicRef = useRef(null);
  const [alertIndex, setAlertIndex] = useState(null);
  const handleCloseDatePicker = (event) => {
    if (
      alertDatePicRef.current &&
      !alertDatePicRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
  };

  const [validations, setValidations] = useState({
    assignee_id: "",
    team_id: "",
    remarks: "",
    ids: "",
  });

  const assignUpdateApi = async () => {
    const data = {
      assignee_id: selectedEmailOption != null ? selectedEmailOption.value : "",
      team_id: selectedTeamOption != null ? selectedTeamOption.value : "",
      remarks: remarkType === "single" ? descriptionInputValue : "",
      ids: ticketList,
    };

    const response = await apiCall("put", "ticket/bulk_assign", data);

    if (response?.status === 200 && response?.data?.success === true) {
      success();
      return;
    }

    if (response?.status === 400 && response?.data?.error) {
      const nextValidations = {
        assignee_id: "",
        team_id: "",
        remarks: "",
        ids: "",
      };

      Object.entries(response.data.error).forEach(([key, value]) => {
        nextValidations[key] =
          Array.isArray(value) && value.length > 0 ? value[0] : "";
      });
      setValidations(nextValidations);
    }
  };

  const handleEmailDropdownChange = (option) => {
    setEmailOption(option);
  };
  const handleTeamDropdownChange = (option) => {
    setTeamOption(option);
  };
  const handleChangeRadio = (event) => {
    setRemarksType(event.target.value);
  };
  const handleProjectListChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...selectedTicketList];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].projectOption = selectedOptions;
      setSelectedTicketList(tempList);
    }
  };
  const handleComponentListChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...selectedTicketList];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].componentOption = selectedOptions;
      setSelectedTicketList(tempList);
    }
  };
  const getErrorMsg = (index, field) => {
    if (field === "project_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].project_id != null) {
          return (
            groupedError[index].project_id[0]?.replace(
              `tickets.${index}.project_id`,
              "project"
            ) ?? ""
          );
        }
      }
    }
    if (field === "component_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].component_id != null) {
          return (
            groupedError[index].component_id[0]?.replace(
              `tickets.${index}.component_id`,
              "component"
            ) ?? ""
          );
        }
      }
    }
    if (field === "closing_date") {
      if (groupedError[index] != null) {
        if (groupedError[index].closing_date != null) {
          return (
            groupedError[index].closing_date[0]?.replace(
              `tickets.${index}.closing_date`,
              "closing date"
            ) ?? ""
          );
        }
      }
    }
    if (field === "work_duration") {
      if (groupedError[index] != null) {
        if (groupedError[index].work_duration != null) {
          return (
            groupedError[index].work_duration[0]?.replace(
              `tickets.${index}.work_duration`,
              "working duration"
            ) ?? ""
          );
        }
      }
    }
    if (field === "description") {
      if (groupedError[index] != null) {
        if (groupedError[index].description != null) {
          return (
            groupedError[index].description[0]?.replace(
              `tickets.${index}.description`,
              "description"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };
  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <div
                style={{
                  paddingLeft: "4px",
                  fontSize: "20px",
                  fontWeight: "500",
                  color: "#212129",
                }}
              >
                Bulk assign tickets
              </div>
            </div>
            <div className="style-justify-end">
              <div
                onClick={onHide}
                className="style-justify-center cursor-pointer"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100px",
                  border: "1px solid #EBEBEB",
                }}
              >
                <img src={ModalCloseIcon} alt="close" />
              </div>
              {/*  <ModalCloseIcon
                style={{ cursor: "pointer" }}
                onClick={onHide}
              /> */}
            </div>
          </div>

          <div style={{ marginTop: "8px" }}>
            <Row style={{ display: "flex", flexWrap: "wrap" }}>
              <Col sm={12} style={{ marginTop: "16px" }}>
                <p
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "17.55px",
                    color: "#212129",
                    marginBottom: "8px",
                  }}
                >
                  Team<span style={{ color: "red" }}> *</span>
                </p>

                <SearchWithAPI
                  onDropdownChange={handleTeamDropdownChange}
                  apiUrl={`get_team`}
                  placeholder={"Team"}
                  selectedValue={
                    selectedTeamOption != null ? selectedTeamOption.label : ""
                  }
                  selectedOption={selectedTeamOption}
                />

                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.team_id}
                </span>
              </Col>
              <Col sm={12} style={{ marginTop: "16px" }}>
                <p
                  style={{
                    fontFamily: "Satoshi",
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "17.55px",
                    color: "#212129",
                    marginBottom: "8px",
                  }}
                >
                  Assign to<span style={{ color: "red" }}> *</span>
                </p>

                <SearchWithAPI
                  onDropdownChange={handleEmailDropdownChange}
                  apiUrl={`get_employee`}
                  params={
                    selectedTeamOption?.value
                      ? { team_id: selectedTeamOption.value }
                      : {}
                  }
                  placeholder={"Assign To"}
                  selectedValue={
                    selectedEmailOption != null ? selectedEmailOption.label : ""
                  }
                  selectedOption={selectedEmailOption}
                />

                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.assignee_id}
                </span>
              </Col>
              <Col sm={12} style={{ marginTop: "16px" }}>
                <div
                  style={{
                    paddingTop: "6px",
                    paddingBottom: "6x",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#212129",
                  }}
                >
                  Notes{" "}
                  <span
                    style={{
                      paddingLeft: "4px",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#212129",
                      opacity: "0.6",
                    }}
                  >
                    (Optional)
                  </span>
                </div>
                <textarea
                  type="text"
                  placeholder=" "
                  className="form-control mt-1"
                  value={descriptionInputValue}
                  rows={3}
                  onChange={(event) => {
                    setDescriptionInputValue(event.target.value); // Update state with input value
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                  }}
                >
                  {validations.remarks}
                </span>
              </Col>
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  marginTop: "16px",
                }}
              >
                <div
                  onClick={onHide}
                  style={{
                    cursor: "pointer",
                    width: "176px",
                    height: "44px",
                    marginLeft: "8px",
                    marginRight: "8px",
                    borderRadius: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#FFFFFF",
                    border: "0.6px solid #E5E5E5",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#1E1E1E",
                    }}
                  >
                    Cancel
                  </div>
                </div>
                <div
                  onClick={(e) => {
                    if (loading === false) {
                      assignUpdateApi();
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    width: "176px",
                    height: "44px",
                    marginLeft: "8px",
                    marginRight: "8px",
                    borderRadius: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#3253EB",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#FFFFFF",
                    }}
                  >
                    Assign
                  </div>
                </div>
              </Row>
            </Row>

            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkAssignUpdateModal;
